import { lazy } from 'react'

import { Checkbox, Group, Image, List, Style, TextInput } from '@makeswift/runtime/controls'

import { runtime } from '@/lib/makeswift/runtime'

import { FolderStructure } from '@/utils/makeswift/constants'

runtime.registerComponent(
	lazy(() => import('./SideNavigation').then((module) => ({ default: module.SideNavigation }))),
	{
		type: 'side-navigation',
		label: `${FolderStructure.UnderDevelopment}/Side Navigation`,
		props: {
			className: Style(),
			navigationItems: List({
				label: 'Navigation Items',
				type: Group({
					label: 'Item',
					preferredLayout: Group.Layout.Inline,
					props: {
						title: TextInput({ label: 'Title' }),
						icon: Image({
							label: 'icon',
							format: Image.Format.URL
						}),
						children: List({
							type: Group({
								label: 'Children Item',
								preferredLayout: Group.Layout.Inline,
								props: {
									title: TextInput({ label: 'Title' }),
									icon: Image({
										label: 'icon',
										format: Image.Format.URL
									}),
									url: TextInput({ label: 'URL', defaultValue: '#' })
								}
							}),
							getItemLabel(item) {
								return item?.title ?? 'Children Title'
							}
						})
					}
				}),
				getItemLabel(item) {
					return item?.title ?? 'Navigation Item'
				}
			}),
			header: Group({
				label: 'Header',
				preferredLayout: Group.Layout.Inline,
				props: {
					showHeader: Checkbox({ label: 'Show Header', defaultValue: false }),
					logo: Image({
						label: 'icon',
						format: Image.Format.URL
					})
				}
			})
		}
	}
)
